<template>
  <gmap-map
    :center="computedCenter"
    :zoom="computedZoom"
    :options="mapOptions"
    ref="map"
  >
    <slot> </slot>
  </gmap-map>
</template>

<script>
import * as VueGoogleMaps from "vue2-google-maps";
export default {
  name: "GoogleMap",
  props: {
    center: {
      type: Object,
      default: null
    },
    zoom: {
      type: Number,
      default: 4
    }
  },
  data() {
    return {
      defaultCenter: { lat: -14.2400732, lng: -53.1805017 },
      defaultZoom: 4,
      mapOptions: {
        streetViewControl: false,
        mapTypeControl: false
      }
    };
  },
  computed: {
    computedCenter() {
      if (this.center && (this.center.lat !== 0 || this.center.lng !== 0)) {
        return this.center;
      } else {
        return this.defaultCenter;
      }
    },
    computedZoom() {
      if (this.center && this.center.lat === 0 && this.center.lng === 0) {
        return this.defaultZoom;
      } else {
        if (this.zoom) {
          return this.zoom;
        } else {
          return this.defaultZoom;
        }
      }
    }
  },
  methods: {
    fitBounds(bounds) {
      const mapObject = this.$refs.map.$mapObject;
      if (mapObject) {
        mapObject.fitBounds(bounds);
      } else {
        console.error("Map object is undefined.");
      }
    }
  },
  mounted() {
    this.$refs.map.$mapPromise
      .then(mapObject => {
        mapObject.addListener("rightclick", e => {
          this.$emit("mapRightClick", e);
        });
        this.fitBounds();
      })
      .catch(error => {
        console.error("Error initializing map:", error);
      });
  },
  beforeMount() {
    VueGoogleMaps.loadGmapApi({
      key: this.$store.getters.googleApiKey,
      libraries: "places"
    });
  }
};
</script>
